export const SERVER_URL = '/api'
// export const SERVER_URL = 'http://localhost:8000'
export const DEFAULT_MESSAGE_COUNT = 5
